import type { KlareoClient, TokenExchangeResponse } from '@klareospace/pharos-lib-types';
import axios from 'axios';
import { DEFAULT_HTTP_TIMEOUT_MS } from '../constants';

export interface TokenExchangeConfig {
  /** Calling client app (see `KLAREO_CLIENT`). When set, minted into the JWT `client` claim at exchange. Omit for web. */
  client?: KlareoClient;
  /** Base URL of the admin-auth API (e.g., http://localhost:3010) */
  exchangeUrl: string;
}

/**
 * Exchange a Firebase ID token for a Pharos (Klareo) JWT.
 */
export async function exchangeFirebaseToken(
  firebaseIdToken: string,
  config: TokenExchangeConfig,
): Promise<TokenExchangeResponse> {
  const baseUrl = config.exchangeUrl.replace(/\/+$/, '');
  const response = await axios.post<TokenExchangeResponse>(
    `${baseUrl}/exchange`,
    config.client ? { client: config.client } : undefined,
    {
      headers: {
        Authorization: `Bearer ${firebaseIdToken}`,
      },
      timeout: DEFAULT_HTTP_TIMEOUT_MS,
    },
  );
  return response.data;
}

/**
 * Refresh an expired Pharos JWT using a stateless refresh token.
 * Calls POST /refresh with the expired Bearer token and the refresh token in the body.
 */
export async function refreshPharosToken(
  expiredToken: string,
  refreshToken: string,
  config: TokenExchangeConfig,
): Promise<TokenExchangeResponse> {
  const baseUrl = config.exchangeUrl.replace(/\/+$/, '');
  const response = await axios.post<TokenExchangeResponse>(
    `${baseUrl}/refresh`,
    { refreshToken },
    {
      headers: { Authorization: `Bearer ${expiredToken}` },
      timeout: DEFAULT_HTTP_TIMEOUT_MS,
    },
  );
  return response.data;
}
